export default __webpack_public_path__ + "locales/sl/SharingPanel.json?hash=ed43f8e13f48f0fe27493a0708295b12";